var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none",
    viewBox: "0 0 18 18"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M3.97 3.97a.75.75 0 0 1 1.06 0L9 7.94l3.97-3.97a.75.75 0 1 1 1.06 1.06L10.06 9l3.97 3.97a.75.75 0 1 1-1.06 1.06L9 10.06l-3.97 3.97a.75.75 0 0 1-1.06-1.06L7.94 9 3.97 5.03a.75.75 0 0 1 0-1.06",
    clipRule: "evenodd"
  })));
};
export default SvgClose;